<dgx-search-landing-page
  [title]="'Core_Opportunities' | translate"
  [hideFilters]="true"
  [customLayout]="true"
  [hideOrgSelector]="true"
  [searchOrigin]="searchOrigin"
  [suggestionSource]="suggestionSource"
  [showSearchTabs]="showSearchTabs"
  (searchTerm)="updateSearchTerm($event)"
>
  <dgx-browse-opportunities
    [initialTerm]="searchTerm$ | async"
    [hideFooter]="true"
  ></dgx-browse-opportunities>
</dgx-search-landing-page>
